import axios from "axios"

function getStudentInterviewReports({id}) {
    return axios.get(`api/v1/students/${id}/interview-reports`)
}

function getInterviewReport({hash}) {
    return axios.get(`api/v1/interview-reports/${hash}`)
}

function sendParentSatisfaction({id}, formData) {
    return axios.post(`api/v1/interview-reports/${id}/parent-satisfaction`, formData)
}

export const interviewReportService = {
    getStudentInterviewReports,
    getInterviewReport,
    sendParentSatisfaction,
}

